import { render, staticRenderFns } from "./CallAmapBtn.vue?vue&type=template&id=45a7c2fb"
import script from "./CallAmapBtn.vue?vue&type=script&lang=js"
export * from "./CallAmapBtn.vue?vue&type=script&lang=js"
import style0 from "./CallAmapBtn.vue?vue&type=style&index=0&id=45a7c2fb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports